import type { CompressOption } from "@/utils/engines/ImageBase";

export const DefaultCompressOption: CompressOption = {
  preview: {
    maxSize: 256
  },
  resize: {
    method: undefined,
    width: undefined,
    height: undefined
  },
  format: {
    target: undefined,
    transparentFill: "#FFFFFF"
  },
  jpeg: {
    quality: 0.7
  },
  png: {
    colors: 180,
    dithering: 0.55
  },
  gif: {
    colors: 128,
    dithering: false
  },
  avif: {
    quality: 50,
    speed: 8
  }
};
